import { useDispatch } from '@redux';
import { TLayoutItem, updateLayout } from '@redux/layouts/actions';
import { Form, Input, Modal } from 'antd';
import React, { useImperativeHandle, useState } from 'react';

type TAddNewView = {
  existLayouts: TLayoutItem[];
};

const RenameModal = ({ existLayouts }: TAddNewView, ref) => {
  const [selected, setSelected] = useState<TLayoutItem | null>(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const onCancel = () => {
    setSelected(null);
    form.resetFields();
  };
  const onFinish = (values) => {
    dispatch(updateLayout({ ...selected, title: values.title }));
    onCancel();
  };

  useImperativeHandle(
    ref,
    () => ({
      setSelected: (e: TLayoutItem | null) => {
        setSelected(e);
        if (e) {
          form.setFieldValue('title', e.title || '');
        }
      },
    }),
    [setSelected],
  );

  return (
    <Modal
      onOk={form.submit}
      onCancel={onCancel}
      open={!!selected}
      title="Rename View"
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          rules={[
            {
              required: true,
              message: 'Please input title',
            },
            () => ({
              validator(_, value) {
                if (
                  !value ||
                  !existLayouts.filter((e) => e.title === value).length
                ) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The title is exist'));
              },
            }),
          ]}
          name="title"
          label="Title"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(RenameModal);
